<div class="padding-small entity-card">
  <div class="flex flex-grow">
    <open-svg-icon [name]="iconName" class="xsmall"></open-svg-icon>
    <div class="entity-card-details">
      <h4 class="entity-card-title">{{ title }}</h4>
      <span *ngIf="subtitle?.length">{{ subtitle }}</span>
    </div>
  </div>

  <div class="entity-card-actions">
    <ng-content></ng-content>
  </div>
</div>